<style lang="stylus" scoped>
@import '../css/var'

.tabGrid
  display flex

.cell
  display flex
  flex 0 1 50%
  align-items center

.cellContent
  text-align center
  width 100%
  font-size (32pt / $pt-ratio)

.active
  color #30C27C

.inactivated
  color #CCD5D8

.iconsize
  pt(32)

</style>
<template>
 <div class="tabGrid">
  <a class="cell"  @click="click1">
    <div class="cellContent" :class="active1 === true ? 'active' : 'inactivated'">
      <i class="icon iconsize">&#xe603;</i>
      <span>首页</span>
    </div>
  </a>
  <a class="cell" @click="click2">
    <div class="cellContent" :class="active2 === true ? 'active' : 'inactivated'">
      <i class="icon iconsize">&#xe64e;</i>
      <span>我的</span>
    </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    active1: true,
    active2: false
  },
  methods: {
    increment (value) {
      this.$emit('click', value)
    },
    click1 () {
      this.increment('homePage')
    },
    click2 () {
      this.increment('my')
    }
  }
}
</script>


// WEBPACK FOOTER //
// tab.vue?74a80b67